document.addEventListener('turbo:load', () => {
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuButton = document.getElementById('mobile-menu-button');

  mobileMenu.addEventListener('toggle', (event) => {
    const closedMenu = document.getElementById('mobile-menu-closed');
    const openMenu = document.getElementById('mobile-menu-open');

    if (event.newState === 'open') {
      window.scrollTo(0, 0);
      closedMenu.classList.add('hidden');
      openMenu.classList.remove('hidden');
      document.body.classList.add('overflow-y-hidden')
    } else {
      closedMenu.classList.remove('hidden');
      openMenu.classList.add('hidden');
      document.body.classList.remove('overflow-y-hidden')
    }
  });

  // Parents Sharing Link - Desktop

  const parentsSharingContainer = document.querySelector('.parents-sharing-container');

  if (parentsSharingContainer) {
    const parentsSharingOpener = document.querySelector('.parents-sharing-opener');
    const parentsSharingPanel = document.querySelector('.parents-sharing');

    parentsSharingContainer.addEventListener('click', (event) => {
      if(event.target.classList.contains('parents-sharing-opener')) {
        parentsSharingContainer.classList.toggle('bg-grey-standard');
      }
    });

    // Open / Close the parents sharing panel
    parentsSharingOpener.addEventListener('click', (event) => {
      parentsSharingPanel.classList.toggle('hidden');
    });

    // Close the parents sharing panel when clicking away
    document.addEventListener('click', (event) => {
      if (!parentsSharingContainer.contains(event.target)) {
        parentsSharingPanel.classList.add('hidden');
        parentsSharingContainer.classList.remove('bg-grey-standard');
      }
    });

    // Parents Sharing Link - Mobile

    const mobileParentsSharingContainer = mobileMenu.querySelector('.parents-sharing-container');
    const mobileParentsSharingOpener = mobileMenu.querySelector('.parents-sharing-opener');
    const mobileParentsSharingPanel = mobileMenu.querySelector('.parents-sharing');

    // Open / Close the parents sharing panel
    mobileParentsSharingOpener.addEventListener('click', (event) => {
      mobileParentsSharingPanel.classList.toggle('hidden');
    });

    // Close the parents sharing panels when clicking away
    document.addEventListener('click', (event) => {
      if (!mobileParentsSharingContainer.contains(event.target)) {
        mobileParentsSharingPanel.classList.add('hidden');
        mobileParentsSharingContainer.classList.remove('bg-grey-standard');
      }
    });

    // Parents Sharing Copy Link
    const parentsSharingCopyLinkButtons = document.querySelectorAll('a[data-copy="true"]');

    parentsSharingCopyLinkButtons.forEach((parentsSharingCopyLinkButton) => {
      parentsSharingCopyLinkButton.addEventListener('click', (event) => {
        const input = document.querySelector(`#${parentsSharingCopyLinkButton.dataset.target}`);
        const notice = document.querySelector(`.${parentsSharingCopyLinkButton.dataset.notice}`);

        const link = new Blob([input.value], { type: "text/plain" });

        const data = new ClipboardItem({
          "text/plain": link
        });

        navigator.clipboard.write([data]);

        if(notice) {
          notice.classList.remove('hidden');
          setTimeout(() => {
            notice.classList.add('hidden');
          }, 1800);
        }
      });
    });
  }
});
